import { useCallback, useEffect, useState } from "react"
import axios from "axios"
import { API_BASE } from "../../../config/appConfig"

function buildAuthConfig(clinicId) {
  const token = localStorage.getItem("odontoflow_token") || ""

  const headers = {}

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  if (clinicId && clinicId !== "ALL") {
    headers["x-clinic-id"] = clinicId
  }

  return { headers }
}

export function useClinicPlanSnapshot(clinicId) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    if (!clinicId || clinicId === "ALL") {
      setData(null)
      setError(null)
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError(null)

      const response = await axios.get(
        `${API_BASE}/subscriptions/clinic-plan`,
        {
          ...buildAuthConfig(clinicId),
          params: { clinicId }
        }
      )

      setData(response?.data || null)
      setError(null)
    } catch (err) {
      setData(null)
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [clinicId])

  useEffect(() => {
    load()
  }, [load])

  useEffect(() => {
    function handleRefresh() {
      load()
    }

    window.addEventListener("odontoflow:subscription-updated", handleRefresh)
    window.addEventListener("odontoflow:clinics-updated", handleRefresh)

    return () => {
      window.removeEventListener("odontoflow:subscription-updated", handleRefresh)
      window.removeEventListener("odontoflow:clinics-updated", handleRefresh)
    }
  }, [load])

  return {
    data,
    loading,
    error,
    refresh: load
  }
}